import { Factory } from './factory';
import { Worksheet } from '../worksheet';
import { HomeworkFactory } from './homework-factory';

export class WorksheetFactory implements Factory<Worksheet> {

    buildFromFactory(): Worksheet {
        return undefined;
    }

    buildFromObject(jsonObject: any): Worksheet {
        const worksheet = new Worksheet();
        worksheet.id = jsonObject.id;
        worksheet.name = jsonObject.name;

        if (jsonObject.homework) {
            const homeworkFactory = new HomeworkFactory();
            const homework= homeworkFactory.buildFromObject(jsonObject.homework);
            if (jsonObject.homework.assignments) {
                homework.exercises = jsonObject.homework.assignments;
            }

            worksheet.homework = homework;
        }

        return worksheet;
    }
}
